import * as React from 'react';
import type { SVGProps } from 'react';

export const PaintIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30 8C30 6.9 29.1 6 28 6H26V5C26 3.3 24.7 2 23 2H5C3.3 2 2 3.3 2 5V9C2 10.7 3.3 12 5 12H23C24.7 12 26 10.7 26 9V8H28V14H15C13.9 14 13 14.9 13 16V18H11V30H17V18H15V16H28C29.1 16 30 15.1 30 14V8ZM24 9C24 9.6 23.6 10 23 10H5C4.4 10 4 9.6 4 9V5C4 4.4 4.4 4 5 4H23C23.6 4 24 4.4 24 5V9ZM15 20V28H13V20H15Z"
      fill="currentColor"
    />
  </svg>
);
